import React, { useEffect, useRef, useState } from 'react';
import styles from './index.module.scss';
import starAssets from './imagePage';
import useOnClickOutside from '../../hooks/useOnClickOutside';
import GlobalLoader from '../../components/GlobalLoader';
import { ctLogV2 } from '../../utils/cleverTapLogger.utils';
import { useIdHash } from '../../hooks/custom.hooks';

function AboutStar() {
  const [activeTab, setActiveTab] = useState('Online');
  const [activeIndex, setActiveIndex] = useState(null);
  const fqRef = useRef(null);
  const [loading, setLoading] = useState(true);
  const { custId: cid } = useIdHash();

  useOnClickOutside(fqRef, () => {
    setActiveIndex(null);
  });

  const faqList = [
    {
      question: 'How will I earn TWID Stars?',
      answer:
        'Earn TWID Stars every time you make UPI payments by scanning any verified merchant QR, paying bills on the TWID app, or shopping across top online & offline brands.',
    },
    {
      question: 'Will I also earn TWID Stars if my UPI payment fails?',
      answer: 'No, TWID Stars will not be credited on failed transactions.',
    },
    {
      question:
        'Can I combine TWID Stars with other merchant offers while making a payment?',
      answer:
        'Yes, you can combine TWID Stars with other merchant offers while redeeming TWID Stars.',
    },
    {
      question: 'Do TWID Stars expire?',
      answer: (
        <>
          Yes, TWID Stars expire 90 days from the date of issuance. Check the{' '}
          <b>My Rewards</b> section in your app to view Rewards that expire.
        </>
      ),
    },
  ];
  const twidIntro = [
    {
      img: starAssets.Scanner,
      title: 'Scan',
      sub_title: 'QR Code',
    },
    {
      img: starAssets.TwidStars,
      title: 'TWID Stars',
      sub_title: '= Real Cash',
    },
    {
      img: starAssets.fivepercent,
      title: 'Earn up to',
      sub_title: '5% TWID Stars',
    },
  ];

  const brandList = [
    {
      title: 'Online stores',
      images: [
        starAssets.swiggy,
        starAssets.jiomart,
        starAssets.bookmyshow,
        starAssets.macdonld,
        starAssets.netmeds,
        starAssets.es,
        starAssets.confirmtkt,
        starAssets.zoomin,
      ],
    },
    {
      title: 'Offline stores',
      images: [
        starAssets.indianoil,
        starAssets.dmart,
        starAssets.lifestyle,
        starAssets.pvr,
        starAssets.pantaloons,
        starAssets.pizzahut,
        starAssets.starbuks,
        starAssets.shopperstop,
      ],
    },
  ];
  const stepData = {
    Online: [
      { icon: starAssets.store, title: 'Choose Merchant' },
      { icon: starAssets.star, title: 'Select ‘Pay with Rewards’' },
      { icon: starAssets.twidstar, title: 'Choose ‘TWID Stars’' },
      { icon: starAssets.saving, title: 'Get instant savings' },
    ],
    Offline: [
      { icon: starAssets.stepScanner, title: 'Scan Merchant QR (Dynamic)' },
      { icon: starAssets.star, title: 'Choose Rewards to apply' },
      { icon: starAssets.cash, title: 'Get Cashback (rewards applied)' },
      { icon: starAssets.bank, title: 'Transfer to Bank' },
    ],
  };
  const steps = stepData[activeTab];

  useEffect(() => {
    const allImages = [
      starAssets.scanner,
      starAssets.shadedBackGroud,
      ...twidIntro.map((item) => item.img),
      ...brandList.flatMap((brand) => brand.images),
      ...stepData.Online.map((item) => item.icon),
      ...stepData.Offline.map((item) => item.icon),
      starAssets.down,
      starAssets.activeuser,
    ];

    let loadedCount = 0;
    const totalImages = allImages.length;

    allImages.forEach((src) => {
      const img = new Image();
      img.src = src;
      img.onload = img.onerror = () => {
        loadedCount++;
        if (loadedCount === totalImages) {
          setLoading(false);
        }
      };
    });
  }, []);

  useEffect(() => {
    ctLogV2({
      eventName: 'appStarDetailsInIssuerListingViewed',
      customerId: cid,
    });
  }, []);

  const toggleAccordion = (index) => {
    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  if (loading) {
    return <GlobalLoader />;
  }

  return (
    <div className={styles.starMainContainer}>
      {/* hero Image */}
      <div className={styles.heroImageContaier}>
        <img src={starAssets.scanner} alt="scan_img" />
      </div>
      {/* Twid Star */}
      <div className={styles.textContainer}>
        <div className={styles.heading}>TWID Stars</div>
        <div className={styles.subHeading}>Ab UPI bana Rewarding!</div>
        <div className={styles.text}>India’s 1st Loyalty Program on UPI</div>
      </div>
      {/* star intro */}
      <div
        className={styles.introContainer}
        style={{
          backgroundImage: `url(${starAssets.shadedBackGroud})`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      >
        <div className={styles.heading}>How to Earn TWID Stars?</div>
        <div className={styles.AboutStarContainer}>
          {twidIntro?.map((elem, index) => {
            const isOdd = index % 2 !== 0;
            return (
              <div
                key={index}
                className={`${styles.renderCard} ${isOdd ? styles.oddCard : ''}`}
              >
                <img src={elem.img} alt={elem.title} />
                <div>{elem?.title}</div>
                <div>{elem?.sub_title}</div>
              </div>
            );
          })}
        </div>
      </div>

      {/*  Redeem Star */}
      <div className={styles.redeemContainer}>
        <div className={styles.heading}>Where can you redeem TWID Stars?</div>
        <div className={styles.brandContainer}>
          {brandList?.map((elem, index) => {
            return (
              <div key={index} className={styles.merchantContainet}>
                <div
                  className={styles.title}
                  style={{
                    marginTop:
                      elem?.title.toLowerCase().includes('offline') && '16px',
                  }}
                >
                  {elem?.title}
                </div>
                <div className={styles.imgMainContainer}>
                  <>
                    {elem?.images?.map((brand, index) => {
                      return (
                        <div key={index} className={styles.imgContainer}>
                          <img src={brand} />
                        </div>
                      );
                    })}
                  </>
                  <div className={styles.addMore}>
                    36,000+ <br /> stores
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* how to redeem */}
      <div className={styles.redeemContent}>
        <div className={styles.title}>How to Redeem TWID Stars?</div>

        <div className={styles.tabs}>
          {['Online', 'Offline'].map((tab) => (
            <button
              key={tab}
              className={`${styles.tab} ${activeTab === tab ? styles.active : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className={styles.separator} />

        <div className={styles.steps}>
          {steps?.map((step, index) => (
            <div key={index} className={styles.step}>
              <div className={styles.iconWrapper}>
                <img src={step.icon} alt={`step-${index + 1}`} />
                {index !== steps.length - 1 && (
                  <div className={styles.dottedLine} />
                )}
              </div>
              <div className={styles.text}>
                <div className={styles.stepNumber}>STEP {index + 1}</div>
                <div className={styles.stepTitle}>{step.title}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Active Users */}
      <div className={styles.activeUser}>
        <img src={starAssets.activeuser} />
        <div style={{ marginLeft: '8px' }}>
          <span style={{ color: 'rgba(132, 253, 172, 1)' }}>
            1.5 million+ people
          </span>{' '}
          <span style={{ color: 'rgba(250, 249, 255, 1)' }}>
            earning TWID Stars
          </span>
        </div>
      </div>

      {/*  Frequent Asked question */}
      <div className={styles.fqContainer}>
        <div className={styles.heading}>Frequently asked Questions</div>
        <div ref={fqRef} className={styles.listContainer}>
          {faqList.map((item, index) => (
            <div key={index} className={styles.section}>
              <div
                onClick={() => toggleAccordion(index)}
                className={styles.question}
              >
                <div style={{ width: '85%' }}>{item.question}</div>
                {/* <span>{activeIndex === index ? '^' : '▼'}</span> */}
                <img
                  src={starAssets.down}
                  alt="down_img"
                  style={{
                    transform:
                      activeIndex === index ? 'rotate(180deg)' : 'rotate(0deg)',
                    transition: 'transform 0.3s ease',
                  }}
                />
              </div>
              {activeIndex === index && (
                <div className={styles.answer} style={{ width: '100%' }}>
                  {item.answer}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default AboutStar;
